import React from 'react';
import { SetTemplate } from '../database';

interface SetEditorProps {
  sets: SetTemplate[];
  onChange: (sets: SetTemplate[]) => void;
}

const SetEditor: React.FC<SetEditorProps> = ({ sets, onChange }) => {
  const addSet = () => {
    const newSet: SetTemplate = {
      targetReps: 10,
      order: sets.length
    };
    onChange([...sets, newSet]);
  };

  const updateSet = (index: number, targetReps: number) => {
    const updatedSets = sets.map((set, i) =>
      i === index ? { ...set, targetReps } : set
    );
    onChange(updatedSets);
  };

  const removeSet = (index: number) => {
    const updatedSets = sets.filter((_, i) => i !== index);
    onChange(updatedSets);
  };

  return (
    <div className="space-y-2">
      <div className="flex justify-between items-center">
        <label className="text-sm font-medium text-gray-700">Sets</label>
        <button
          type="button"
          onClick={addSet}
          className="text-blue-600 text-sm"
        >
          + Add Set
        </button>
      </div>
      
      {sets.map((set, index) => (
        <div key={index} className="flex items-center space-x-2">
          <span className="text-sm text-gray-500 w-12">Set {index + 1}:</span>
          <input
            type="number"
            value={set.targetReps || ''}
            onChange={(e) => {
              const value = e.target.value;
              if (value === '' || value === '0') {
                updateSet(index, 0);
              } else {
                updateSet(index, parseInt(value) || 0);
              }
            }}
            className="w-20 p-1 border border-gray-300 rounded text-sm"
            min="1"
            max="50"
          />
          <span className="text-sm text-gray-500">reps</span>
          {sets.length > 1 && (
            <button
              type="button"
              onClick={() => removeSet(index)}
              className="text-red-600 text-sm ml-2"
            >
              Remove
            </button>
          )}
        </div>
      ))}
      
      {sets.length === 0 && (
        <button
          type="button"
          onClick={addSet}
          className="w-full p-2 border-2 border-dashed border-gray-300 rounded text-gray-500 text-sm"
        >
          Add first set
        </button>
      )}
    </div>
  );
};

export default SetEditor;